export default {
  title: 'Remise contrat annuel',
  buttons: {
    edit: 'Modifier la remise',
    save: 'Enregistrer la remise',
  },
  toasts: {
    invalid_discount: 'La remise contrat annuel doit être comprise entre {{min}}% et {{max}}%',
  },
};
